var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolnHeroIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10376_20428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97025 8.37C10.4802 8.37 11.7003 7.17 11.7003 5.69C11.7003 4.21 10.4802 3.01001 8.97025 3.01001C7.46025 3.01001 6.24023 4.21 6.24023 5.69C6.24023 7.17 7.46025 8.37 8.97025 8.37Z",
    stroke: "#5C0335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91915 17.97L4.55914 17.3C4.36914 17.2 4.20912 17.05 4.10912 16.86C4.00912 16.67 3.97915 16.45 4.00915 16.24L4.54913 13.07C4.64913 12.49 4.95915 11.96 5.41915 11.58C5.87915 11.2 6.45914 10.99 7.05914 10.99H10.8991C11.4991 10.99 12.0791 11.2 12.5391 11.58C12.9991 11.96 13.2991 12.49 13.3991 13.07L13.9391 16.24C13.9891 16.45 13.9591 16.67 13.8591 16.86C13.7591 17.05 13.5991 17.21 13.3991 17.29L12.0491 17.96",
    stroke: "#5C0335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41992 15.97L6.8399 20.05C6.8499 20.3 6.95991 20.53 7.12991 20.71C7.30991 20.88 7.5399 20.99 7.7999 21H10.0199C10.2699 20.99 10.5099 20.89 10.6899 20.71C10.8699 20.54 10.9699 20.3 10.9799 20.05L11.3899 15.97",
    stroke: "#5C0335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0391 3C15.7591 3 16.4591 3.28001 16.9691 3.79001C17.4791 4.29001 17.769 4.98 17.769 5.69C17.769 6.4 17.4791 7.08 16.9691 7.59C16.4591 8.09 15.7691 8.38 15.0391 8.38",
    stroke: "#B70569",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0508 10.98H16.9408C17.5408 10.98 18.1208 11.19 18.5808 11.57C19.0408 11.95 19.3508 12.48 19.4508 13.06L19.9908 16.23C20.0208 16.44 19.9908 16.66 19.8908 16.85C19.7908 17.04 19.6308 17.19 19.4408 17.29L18.0808 17.96",
    stroke: "#B70569",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0391 20.95H16.1391C16.2691 20.95 16.399 20.94 16.519 20.89C16.639 20.85 16.7491 20.78 16.8491 20.69C16.9391 20.6 17.0191 20.5 17.0691 20.38C17.1191 20.26 17.149 20.14 17.149 20.01L17.5691 15.93",
    stroke: "#B70569",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10376_20428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolnHeroIcon);
export default __webpack_public_path__ + "static/media/voln-hero-icon.3d30e7dfac2ae07ee6c3d90d7badfb34.svg";
export { ForwardRef as ReactComponent };